// Copyright (c) StrangeBee 2023

import React, { ReactElement, useState, useEffect } from 'react';
import { useLocalMessage } from '@Helpers/';
import { DashboardOutput } from 'thehive-sdk';
import { THSelect } from '@Molecules/Inputs/THSelect/THSelect';
import { createWidgetQueryKey } from '@Molecules/Widgets/utils';
import { queryClient } from '@Client';

import './DashboardRefresh.scss';

interface DashboardMenuProps {
    dashboard: DashboardOutput;
}

// eslint-disable-next-line
const defaultSetIntervalId = setInterval(() => {}, 10);
type SetIntervalType = typeof defaultSetIntervalId;

const DashboardRefresh = ({ dashboard }: DashboardMenuProps): ReactElement | null => {
    const i = useLocalMessage();

    const [time, setTime] = useState<number>(0);
    const setContainer = useState<SetIntervalType>()[1];

    const options = [
        {
            label: i('app.dashboard.panel.menu.none'),
            value: 0,
        },
        {
            label: '1m',
            value: 60 * 1000,
        },
        {
            label: '5m',
            value: 60 * 1000 * 5,
        },
        {
            label: '10m',
            value: 60 * 1000 * 10,
        },
        {
            label: '15m',
            value: 60 * 1000 * 15,
        },
    ];

    useEffect(() => {
        setContainer((container) => {
            if (container) {
                clearInterval(container);
            }

            if (time === 0) {
                return;
            }

            return setInterval(() => {
                dashboard.definition.items.forEach((container) => {
                    container.items.forEach((widget) => {
                        queryClient.refetchQueries([createWidgetQueryKey(widget)], { active: true });
                    });
                });
            }, time);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [time, dashboard.definition.items]);

    return (
        <div className="dashboard-refresh">
            <span className="dashboard-refresh__select-label">{i('dashboard.settings.refresh')}</span>
            <THSelect options={options} value={time} onChange={setTime} />
        </div>
    );
};

export default DashboardRefresh;
